export default __webpack_public_path__ + "static/media/papandayan-6.c4130ebd.jpg";